/**
 * Pre-compiled de messages for ScopedSearchInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { searchLabel: `Suche`, selectLabel: `Filtern nach` };
